<script>
export default {
  data() {
    return {
      showUncompleteModal: false
    }
  },

  props: {
    iscomplete: Boolean,
    isselected: Boolean,
    idcategory: Number,
    gourl: String,
    bgimageurl: String,
    name: String,
    percentage: Number,
    buttonlabel: String,

  },

  methods: {
    doGo: function () {
      if (this.iscomplete) {
        this.showUncompleteModal = true
      } else {
        this.Navigate()
      }
    },

    doUnComplete: function () {
      this.Navigate()
    },

    doCancel: function () {
      this.showUncompleteModal = false
    },

    Navigate: function () {
      window.location = this.gourl
    }
  },

}
</script>

<template>
  <a class="text-white" v-on:click="doGo">
    <div class="card border-0" :style="{'background-image': 'url(' + bgimageurl + ')'}">
      <div class="card-body d-flex flex-column category-card">
        <div class="card-text my-auto p-3">
          <div class="text-center font-size-lg" v-text="name"></div>
        </div>
      </div>
      <div class="card-footer p-0 border-0">

        <div class="category-progress-wrap">

          <div class="progress w-100 category-progress">

            <div class="progress-bar bg-primary text-white category-progress-bar"
                 v-if="isselected"
                 role="progressbar"
                 :style="{width: percentage + '%' }"
                 aria-valuenow="{{ percentage }}"
                 aria-valuemin="0"
                 aria-valuemax="100"
                 v-html="percentage + '%'">
            </div>

          </div>

        </div>
        <div :class="['category-button-apply',
        'text-center',
        iscomplete ? 'category-button-complete' : '']">
          <button type="button"
                  class="btn bg-dark text-white w-100 font-size-sm py-2 border-top" v-html="buttonlabel"></button>
        </div>
      </div>

    </div>
  </a>

  <Teleport to="body">
    <div class="bibasappmodal" v-if="showUncompleteModal">
      <div class="bibasappmodal-dialog">
        <div class="bibasappmodal-content">
          <div class="bibasappmodal-header">
            <h2>Edit completed application?</h2>
          </div>
          <div class="bibasappmodal-body">
            <p>Are you sure you want to edit this completed and finalised application?<br>
              You may continue, but doing so will unmark the application as final requiring you to tick the "complete
              and
              final" box again or your application may not be considered for an award.</p>
          </div>
          <div class="bibasappmodal-footer">
            <button class="btn btn-primary rounded-pill" type="button" v-on:click="doUnComplete()">Yes
            </button>
            <button class="btn btn-primary rounded-pill" type="button" v-on:click="doCancel()">No
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

</template>
